///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.edit = abcsetup.rfq.edit || {};
abcsetup.rfq.edit.upload_init = false;
abcsetup.rfq.edit.fields_init = false;
abcsetup.rfq.edit.init_items = false;




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.edit = {
    init: function() {
        abcsetup.setTitle('Submit an RFQ Bid');

        abcsetup.rfq.edit.upload_init = false;
        abcsetup.rfq.edit.fields_init = false;
        abcsetup.rfq.edit.init_items = false;

        // Universal decline all button
        $(document).on('click', '.decline_all', function () {
            $('select[name*="bid"]').each(function(index, field) {
                console.log('$(this): ',$(this));
                $(this).val('0').trigger('change');
                $(this).closest('.card.bid-item').find('.collapse').addClass('show');
            });
            $('.universal_decline_reason').attr('disabled',false).trigger('change');
        });

        $(document).on('click', '.universal_decline_reason', function () {
            var val = $(this).val();
            $(this).closest('form').find('select[name*="decline_reason"]').val(val).trigger('change');
        });

        // init the RFQ common lib
        abcsetup.rfq.common.init();
    },

    /**
     * _jquery.uploader
     *      Uploader attachment buttons and values have been init
     */
    uploadInit: function() {
        abcsetup.rfq.edit.upload_init = true;

        // Update the item states (after fields and uploads have been init)
        if (abcsetup.rfq.edit.fields_init) {
            abcsetup.rfq.edit.updateStates();
        }
    },

    /*
    * _jquery.fieldValidate
    *       Fields have been init - this is the callback
    */
    fieldsInit: function() {
        abcsetup.rfq.edit.fields_init = true;

        // Update the item states (after fields and uploads have been init)
        if (abcsetup.rfq.edit.upload_init) {
            abcsetup.rfq.edit.updateStates();
        }
    },

    /**
     * _jquery.fieldValidate
     *      fieldError callback
     */
    fieldError: function() {
        var errorField = $('form .invalid').first();
        //alert(errorField.parent().html());

        abcsetup.unblockUI();

        if (abcsetup.rfq.edit.init_items) {
            abcsetup.rfq.common.fieldError();
        }
    },


    /**
     * Update the item states (after fields and uploads have been init)
     */
    updateStates: function() {
        $('div.card.bid-item .btn.save-item').each(function() {
            var itemPanel = $(this).closest('.card-body');

            var valid = abcsetup.rfq.common.validateItem(itemPanel, true);

            if (itemPanel.find(':input.bid').val() == '0' && valid) {
                abcsetup.rfq.common.ignoreItem(itemPanel, true);
            }
        });

        abcsetup.rfq.edit.init_items = true;
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone: function() {
        if (abcsetup.uploader.uploadResult.id) {
            var msg = '';

            $('#item-accordion, .item_attachments, .btn-attach').hide();
            $('.control-buttons').parent().hide();

            if (abcsetup.uploader.uploadResult.imported) {
                msg += 'Items successfully imported: ' + abcsetup.uploader.uploadResult.imported + '<br>';
            }

            if (abcsetup.uploader.uploadResult.failed) {
                msg += 'Items imports failed: ' + abcsetup.uploader.uploadResult.failed + '<br>';
            }

            abcsetup.alerts.show('Item Imports', msg, function() {
                abcsetup.blockUI(true);
                window.location.href ='/rfq/' + abcsetup.uploader.uploadResult.id + '/edit';
            });

        } else {
            abcsetup.alerts.show('No items imported', 'Item import failed - please double check the template you specified');
        }
    },
}
